const traffic = {
  't-global-config': '全局配置',
  't-save-config': '保存配置',
  't-time-window': '时间窗口',
  't-time-window-seconds': '时间窗口（秒）',
  't-max-download-count': '最大下载次数',
  't-max-retry-count': '允许重试次数',
  't-global-config-hint': '未单独配置 Partner 将使用此全局默认值。仅对 mpush 类型设备生效。',
  't-circuit-breaker-strategy': '熔断策略',
  't-circuit-breaker-enabled': '该 Partner 将执行独立熔断策略',
  't-circuit-breaker-disabled': '关闭后使用全局配置',
  't-config-params': '配置参数',
  't-time-window-label': '时间窗口',
  't-max-download-label': '最大下载',
  't-max-retry-label': '允许重试',
  't-ban-behavior-title': '封禁后行为说明',
  't-ban-behavior-desc': '重试次数耗尽 → 设备进入封禁状态 → 当前窗口内所有下载请求直接返回 {0}，设备终止下载',
  't-download-settings': '下载设置',
  't-traffic-mgmt': '流量管理',
  "t-error-download-settings": "限流器",
  't-add-config': '新增配置',
  't-edit-config': '编辑配置',
  't-status-enabled': '已开启',
  't-status-disabled': '已停用',
  't-select-partner': '请选择 Partner',
  't-select-partner-required': '请选择 Partner',
  't-fill-time-window': '请填写时间窗口',
  't-save-success': '保存成功',
  't-save-failed': '保存失败',
  't-update-success': '更新成功',
  't-update-failed': '更新失败',
  't-add-success': '新增成功',
  't-add-failed': '新增失败',
  't-load-failed': '数据加载失败',
  't-second': '秒',
  't-times': '次',
  't-fill-max-download': '请填写最大下载次数',
  't-fill-allowed-retry': '请填写允许重试次数',
  't-time-window-range-error': '时间窗口必须在1到7200之间',
  't-max-download-range-error': '最大下载次数必须在5到200之间',
  't-allowed-retry-range-error': '允许重试次数必须在1到20之间',
  't-traffic-overview': '流量概览',
  't-monthly-total-traffic': '本月总流量',
  't-compared-last-month': '较上月',
  't-partner-count': 'Partner 数量',
  't-this-month-new': '本月新增',
  't-over-limit-partner': '超限 Partner',
  't-need-attention': '需关注',
  't-all-partner': '全部 Partner',
  't-all-usage-rate': '全部使用率',
  't-current-month-used-traffic': '当月已用流量',
  't-traffic-limit': '流量上限',
  't-usage-rate': '使用率',
  't-this-month-download-count': '本月下载次数',
  't-normal': '正常',
  't-about-to-exceed': '即将超限',
  't-exceeded': '已超限',
  't-unlimited': '无限',
  't-unlimited-traffic': '无限流量',
  't-view-traffic-detail': '查看流量详情',
  't-download-records': '本月下载记录',
  't-file-name': '文件名称',
  't-file-size': '文件大小',
  't-usage-history': '历史记录',
  't-data-usage-trend': '流量使用趋势',
  't-last-30-days-data-usage-trend': '最近 30 天流量使用趋势',
  't-used-traffic': '已用流量',
  't-last-12-months-traffic-trend': '最近12个月流量趋势',
  't-month': '月份',
  't-all-months': '全部月份',
  't-download-count': '下载次数',
  't-quota-configuration': '流量限制',
  't-global-default-config': '全局默认配置',
  't-global-default-traffic-limit': '全局默认流量上限',
  't-current-config': '当前配置',
  't-quota-global-config-hint': '未单独配置流量上限的 Partner 将使用此默认值。设置为 0 表示无限流量。',
  't-partner-traffic-limit-config': 'Partner 流量上限配置',
  't-config-type': '配置类型',
  't-use-global': '使用全局',
  't-custom': '自定义',
}

export default traffic
